import { render, staticRenderFns } from "./sms-communication-outage.vue?vue&type=template&id=46dd8fa4&scoped=true&"
import script from "./sms-communication-outage.vue?vue&type=script&lang=js&"
export * from "./sms-communication-outage.vue?vue&type=script&lang=js&"
import style0 from "./sms-communication-outage.vue?vue&type=style&index=0&id=46dd8fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd8fa4",
  null
  
)

export default component.exports